
interface IFeaturesTogglesConfig {
    featuresConfig: {
        features: Record<string, any>;
        groups: Array<string>;
    };
}

export function extractFeaturesToggles(): IFeaturesTogglesConfig {
    try {
        const unparsed = document.getElementById('feature_toggle.configs')?.innerText;
        if (!unparsed) {
            throw new Error('Element not found, feature_toggle.configs');
        }
        const parsed = JSON.parse(atob(unparsed));
        return parsed;
    } catch (error) {
        throw new Error(error?.message);
    }
}
